import {setRef, tryCall} from '../../utils';
import {useEffect, useRef} from 'react';

type EventType = 'keydown' | 'keypress' | 'keyup';

export function useKeyboardEffect(eventType: EventType, callback: (event: KeyboardEvent) => void, options?: boolean): void {
	const callbackRef = useRef<(e: KeyboardEvent) => void>();
	setRef(callback, callbackRef);

	useEffect(() => {
		const handler = (event: KeyboardEvent) => tryCall(callbackRef.current, event);

		document.addEventListener(eventType, handler, options);
		return () => document.removeEventListener(eventType, handler, options);
	}, [eventType, options]);
}
